/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { log } from 'utils/logger';
import {
    SET_INVIEW_STATUS,
    SET_INTEGRATION_TYPE_AND_URL,
    SET_OUT_OF_CONTENT,
    SHOW_LOADER
} from 'redux/actions/embed_status';

/* ========== ~~~~~~~~~~ EMBED STATUS : REDUCER ~~~~~~~~~~ ========== */
// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const embedStatus = (state = {}, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case SET_INVIEW_STATUS:
            log("@@@ UPDATING INVIEW STATUS @@@@", action.inViewStatus);
            newState.inView = action.inViewStatus;
            if (!newState.inViewRecorded) newState.inViewRecorded = !!action.inViewStatus;
            return newState;
        case SET_INTEGRATION_TYPE_AND_URL:
            log("@@@ SETTING EMBED STATUS @@@@", action.integrationTypeAndURL);
            newState.integrationType = action.integrationTypeAndURL.integrationType;
            newState.url = action.integrationTypeAndURL.url;
            return newState;
        case SET_OUT_OF_CONTENT:
            newState['outOfContent'] = action.status !== null ? action.status : newState['outOfContent'];
            return newState;
        case SHOW_LOADER:
            newState.showLoader = action.state;
            return newState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default embedStatus;
